import { api } from '@/server/http'; // 导入http中创建的axios实例

// 转JSON
function getparams(params) {
    if (!params) {
        return;
    } else {
        return JSON.stringify(params)
    }
}

// 用户管理
const user = {
    adminuser(data){
        return api.post('user/adminuser',getparams(data))
    },
    admingroup(data){
        return api.post('user/admingroup', getparams(data))
    }
}

const menu = {
    adminmenu(data){
        return api.post('system/adminmenu',getparams(data))
    }
}

const dns = {
    vendor(data){
        return api.post('dns/vendor', getparams(data))  // 服务商管理
    },
    project(data){
        return api.post('dns/project', getparams(data)) //平台管理
    },
    account(data){
        return api.post('dns/account', getparams(data)) // 账号管理
    },
    domain(data){
        return api.post('dns/domain', getparams(data)) // 域名管理
    }
}

const download ={
    downloadManagement(data){  
        return api.post('download/docs', getparams(data))
    }
}
const task= {
    taskDo(data){
        return api.post('task/do', getparams(data))
    }
}



//进行统一导出
export default {
    user,
    menu,
    dns,
    download,
    task
}



// WEBPACK FOOTER //
// ./src/server/index.js